import { RouteLevels } from '@ringba/config/route-levels';

/** Decides when V2 hands a page off to V3, for AngularJS code and Vue 2 components. */
export class V3HandoffService {
  /** @ngInject **/
  constructor(systemFlagsService, VuexStore, whitelabelManager) {
    this._systemFlags = systemFlagsService;
    this._store = VuexStore;
    // Injected: importing its module here would run its `angular.module` calls before the services module defines it.
    this._whitelabel = whitelabelManager;
  }

  /**
   * Whether V2 hands the page for `flag` off to V3 now.
   *
   * `flag` is a route config key.
   * An unknown key, or any other value, counts as `Disabled`.
   *
   * Checks, in order:
   * - `V3Only` hands off.
   * - A whitelabel with custom colours stays in V2, since V3 doesn't support its theme.
   * - `V2Redirect` hands off for an account with the `portal_v3` feature flag.
   *
   * Reads its inputs on each call, so a Vue computed or an AngularJS template that calls it stays current.
   */
  handsOff(flag) {
    const level = levelOf(this._systemFlags.config.routes, flag);
    if (level >= RouteLevels.V3Only) {
      return true;
    }
    if (this._whitelabel.value?.friendlyName && this._whitelabel.hasCustomColors) {
      return false;
    }
    return level >= RouteLevels.V2Redirect && !!this._store.state.currentAccountFeatureFlags?.portal_v3;
  }
}

function levelOf(routes, flag) {
  if (typeof flag !== 'string') {
    return RouteLevels.Disabled;
  }
  // Guard against prototype keys such as 'constructor': the effective routes are a plain object, so they inherit Object.prototype members.
  const level = routes[flag];
  return typeof level === 'number' ? level : RouteLevels.Disabled;
}
